import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import { ReportingObserver } from '@sentry/integrations';

import App from './App';

process.env.REACT_APP_ENV === 'Prod' &&
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_URL,
    release: `technician-app@${process.env.REACT_APP_ENV}`,
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: process.env.REACT_APP_DEPLOYED_URL,
      }),
      new Sentry.Replay({
        networkDetailAllowUrls: process.env.REACT_APP_DEPLOYED_URL,
        networkRequestHeaders: ['Cache-Control'],
        networkResponseHeaders: ['Referrer-Policy'],
      }),
      new ReportingObserver({ types: ['crash'] }),
    ],
    tracesSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.REACT_APP_ENV,
  });

ReactDOM.render(<App />, document.getElementById('root'));
